import MeetingManagerPage from "@Evaluation/AlternativesSurveys/Pages/MeetingManagerPage.vue";
import PanelistMeetingPage from "@Evaluation/AlternativesSurveys/Pages/PanelistMeetingPage.vue";
import PanelistSurveyAlternativePage from "@Evaluation/AlternativesSurveys/Pages/PanelistSurveyAlternativePage.vue";
import PanelistSurveyCriterionPage from "@Evaluation/AlternativesSurveys/Pages/PanelistSurveyCriterionPage.vue";
import PanelistSurveyDashboardPage from "@Evaluation/AlternativesSurveys/Pages/PanelistSurveyDashboardPage.vue";
import ScoringPanelistsPage from "@Evaluation/AlternativesSurveys/Pages/ScoringPanelistsPage.vue";
import ScoringSurveysPage from "@Evaluation/AlternativesSurveys/Pages/ScoringSurveysPage.vue";


export const routes = [
    {
        path: "/portfolio/scoring-surveys/:workspaceId/:projectId/:evalModelId",
        component: ScoringSurveysPage,
    },
    {
        path: "/decision/scoring-surveys/:workspaceId/:projectId/:evalModelId",
        component: ScoringSurveysPage,
    },


    {
        path: "/portfolio/scoring-panelists/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: ScoringPanelistsPage,
    },
    {
        path: "/decision/scoring-panelists/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: ScoringPanelistsPage,
    },

    {
        path: "/portfolio/scoring-review/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: MeetingManagerPage,
    },
    {
        path: "/decision/scoring-review/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: MeetingManagerPage,
    },

    {
        path: "/scoring/meeting/:workspaceId/:surveyId/:projectUserId",
        component: PanelistMeetingPage,
    },
    {
        path: "/scoring/dashboard/:workspaceId/:surveyId/:projectUserId",
        component: PanelistSurveyDashboardPage,
    },
    {
        path: "/scoring/alternative/:workspaceId/:surveyId/:projectUserId/:alternativeId",
        component: PanelistSurveyAlternativePage,
    },
    {
        path: "/scoring/criterion/:workspaceId/:surveyId/:projectUserId/:criterionId",
        component: PanelistSurveyCriterionPage,
    },

]
